/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lab-prescription.reducer';

export const LabPrescriptionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const labPrescriptionEntity = useAppSelector(state => state.labPrescription.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="labPrescriptionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.labPrescription.detail.title">LabPrescription</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.labPrescription.id">Id</Translate>
            </span>
          </dt>
          <dd>{labPrescriptionEntity.id}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.labPrescription.status">Status</Translate>
            </span>
          </dt>
          <dd>{labPrescriptionEntity.status}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.labPrescription.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{labPrescriptionEntity.timestampentry}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.labPrescription.active">Active</Translate>
            </span>
          </dt>
          <dd>{labPrescriptionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.labPrescription.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{labPrescriptionEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.labPrescription.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{labPrescriptionEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.labPrescription.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{labPrescriptionEntity.microSec}</dd>
          <dt>
            <span id="patientType">
              <Translate contentKey="tinyMedicRestApp.labPrescription.patientType">Patient Type</Translate>
            </span>
          </dt>
          <dd>{labPrescriptionEntity.patientType}</dd>
          <dt>
            <span id="exposed">
              <Translate contentKey="tinyMedicRestApp.labPrescription.exposed">Exposed</Translate>
            </span>
          </dt>
          <dd>{labPrescriptionEntity.exposed ? 'true' : 'false'}</dd>
          <dt>
            <span id="otc">
              <Translate contentKey="tinyMedicRestApp.labPrescription.otc">Otc</Translate>
            </span>
          </dt>
          <dd>{labPrescriptionEntity.otc ? 'true' : 'false'}</dd>
          <dt>
            <span id="orderStatus">
              <Translate contentKey="tinyMedicRestApp.labPrescription.orderStatus">Order Status</Translate>
            </span>
          </dt>
          <dd>{labPrescriptionEntity.orderStatus}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.labPrescription.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{labPrescriptionEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.labPrescription.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{labPrescriptionEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.labPrescription.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{labPrescriptionEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.labPrescription.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{labPrescriptionEntity.modifiedByID}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labPrescription.prescription">Prescription</Translate>
          </dt>
          <dd>{labPrescriptionEntity.prescription ? labPrescriptionEntity.prescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labPrescription.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{labPrescriptionEntity.glucoUser ? labPrescriptionEntity.glucoUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labPrescription.servedBy">Served By</Translate>
          </dt>
          <dd>{labPrescriptionEntity.servedBy ? labPrescriptionEntity.servedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labPrescription.orderedBy">Ordered By</Translate>
          </dt>
          <dd>{labPrescriptionEntity.orderedBy ? labPrescriptionEntity.orderedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labPrescription.appointment">Appointment</Translate>
          </dt>
          <dd>{labPrescriptionEntity.appointment ? labPrescriptionEntity.appointment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labPrescription.otcBy">Otc By</Translate>
          </dt>
          <dd>{labPrescriptionEntity.otcBy ? labPrescriptionEntity.otcBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labPrescription.treatmentPlan">Treatment Plan</Translate>
          </dt>
          <dd>{labPrescriptionEntity.treatmentPlan ? labPrescriptionEntity.treatmentPlan.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labPrescription.procedure">Procedure</Translate>
          </dt>
          <dd>{labPrescriptionEntity.procedure ? labPrescriptionEntity.procedure.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/lab-prescription" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lab-prescription/${labPrescriptionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LabPrescriptionDetail;
